<template>
  <div class="listOne" v-show="newList.length > 0">
    <div class="search">
      <el-input v-model="title" placeholder="请输入标题" clearable></el-input>
      <el-button style="margin-left:20px" @click="search">搜索</el-button>
    </div>
    <div v-for="(item, index) in newList" :key="index" class="box-list clearfix" @click="shoDetial(item)">
      <div class="box-list-font fl">
        <div class="title over-one">{{ item.article_title }}</div>
        <div class="info over-two"> {{ item.article_desc }}</div>
        <div class="time">{{ item.publish_time }}</div>
      </div>
    </div>
    <div class="page">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    columnId: {
      type: String,
      default: '',

    }
  },
  data() {
    return {
      newList: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      title: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      let self = this
      this.newList = []
      this.$common.noLoginCallUrl('/api/cp-cms/site/info/getInfoPage', {
        column_id: self.columnId,
        pageNo: self.currentPage,
        pageCount: self.pageSize,
        article_title: self.title
      },
        function (res) {
          if (res.code == '000000') {
            self.newList = res.data.data || []
            self.total = res.data.count
          } else {
            self.$message.warning(res.msg)
          }
        })
    },
    search() {
      this.getList()
    },
    handleSizeChange() {

    },
    handleCurrentChange(item) {
      this.currentPage = item
      this.getList()
    },
    shoDetial(item) {
      this.$emit('detail', item)
    }
  },
  watch: { // 监听，当路由发生变化的时候执行

  }
};
</script>

<style lang="less" scoped>
.listOne {
  .search {
    display: flex;
    width: 500px;
    margin: 20px auto 50px;

  }

  .box-list {
    // width: 800px;
    margin: 20px auto;
    height: 150px;
    padding: 10px;
    cursor: pointer;
    border-bottom: dashed 1px #dedede;

    .box-list-font {
      width: 100%;
      height: 130px;

      .title {
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
        color: #031c98;
      }

      .info {
        font-size: 14px;
        color: #666666;
      }

      .time {
        font-size: 14px;
        margin-top: 20px;
      }
    }
  }

  .page {
    text-align: center;
    margin: 50px 0 20px;
  }
}

@media screen and (max-width: 1025px) {
  .listOne {
    .search {
      width: 100%;
    }
    .box-list{
      height: auto;
      margin: 0;
      padding: 10px 0;
      .box-list-font{
        height: 100px;
        .title{
          margin-bottom: 10px;
        }
        .time{
          margin-top: 10px;
        }
      }
    }
    
  }
  .el-pagination {
    white-space: wrap;
    padding: 0;
    /deep/ .number,
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 5px !important;
      min-width: 20px !important;
    }
    /deep/ .el-pagination__jump{
      margin-left: 5px !important;
    }
  }
}
</style>